module.exports = __webpack_public_path__ + "img/arrow-up.44f7f9a5.svg";